import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ProductField, CalculatorMessagesDto } from "cilor-db-api-shared";
import { Strings } from "../../shared/tools/Strings";

@Injectable({
  providedIn: "root"
})
export class CalculatorMessagesService {

  public pageIndex: number;
  public filter: string;

  public data: CalculatorMessagesDto | null;
  public loading: boolean;
  public error: string | null;

  constructor(
    private readonly httpClient: HttpClient,
  ) {
    this.pageIndex = 0;
    this.filter = "";
    this.data = null;
    this.loading = false;
    this.error = null;
  }

  public async fetchCalculationMessages(
    opts: {
      pageIndex: number,
      filter: string,
    }
  ): Promise<CalculatorMessagesDto> {
    return await this.httpClient.get<CalculatorMessagesDto>(
      "/api/products/calculatormessages",
      {
        params: {
          page: opts.pageIndex.toString(),
          pageSize: (10).toString(),
          sortDirection: "asc",
          filter: opts.filter,
          sortPath: ProductField.modellnummerIntern,
        }
      }
    ).toPromise();
  }

  public async fetch(): Promise<void> {
    try {
      this.loading = true;
      this.data = await this.fetchCalculationMessages(
        {
          pageIndex: this.pageIndex,
          filter: this.filter,
        }
      );
    } catch (e) {
      this.data = null;
      if (e instanceof HttpErrorResponse) {
        this.error = e.error.message;
      } else if (e instanceof Error) {
        this.error = e.message;
      } else {
        this.error = Strings.unknownError;
      }
    } finally {
      this.loading = false;
    }
  }
}
